<div
    class="icon-zone"
    [style.--icon-button-color]="color()"
    [style.--icon-button-hover-color]="hoverColor()">
    <fa-icon
        [icon]="icon()"
        [size]="iconSize() ?? '2xs'" />
</div>
